import { colors } from '.';

const metrics = {
  container_max_width: '90rem',

  box_shadow: `2px 2px 5px ${colors.gray}`,
};

export default metrics;
